module.exports = __webpack_public_path__ + "static/img/nodata.fc76d17.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/nodata.png
// module id = sjts
// module chunks = 0